import React from "react";
import {
  Card,
  Form,
  Input,
  Button,
  Checkbox,
  Alert,
  Image,
  message,
  Row,
  Col,
  Modal,
  notification,
} from "antd";
import { connect } from "react-redux";
import { professionalAction, userActions } from "../../_actions";
import "./newLoginPage.css";
import { Carousel } from "antd";
import { slide1_1, slide1_2, slide1_3, bg1_1 } from "./sliders/slider";
import { UserOutlined, LockOutlined, PhoneOutlined } from "@ant-design/icons";
import { decode as base64_decode, encode as base64_encode } from "base-64";
import ReCAPTCHA from "react-google-recaptcha";
import "./../../responsive.css";
import axios from "axios";
import independenceLoginBanner from "../../_assets/IMAGE.png";
const TEST_SITE_KEY = process.env.REACT_APP_SITE_KEY;
const DELAY = 1500;

const contentStyle = {
  height: "80vh",
  color: "#fff",
  lineHeight: "100vh",
  textAlign: "center",
  background: "#364967",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};
class NewLoginPage extends React.Component {
  constructor(props) {
    super(props);
    // reset login status
    this.props.dispatch(userActions.logout());
    this.onFinish = this.onFinish.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
    const { loggedIn, error } = this.props;
    this.state = {
      loggedIn: loggedIn,
      // error: error,
      callback: "not fired",
      value: "[empty]",
      load: false,
      expired: "false",
      recaptchavalidate: false,
      recaptchaLoaded: false,
      ipAddress: "",
      isChecked: false,
      userid: "",
      password: "",
      phone: "",
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("this.props.loggedIn", this.props.loggedIn, this.props.error);
    if (
      this.props.loggedIn == false &&
      (this.props.error == "Bad Request" || this.props.error == "") &&
      prevProps.loggedIn != this.props.loggedIn
    ) {
      this.setState({
        showError: true,
        errorMessage: "Invalid Credentials!",
      });
      setTimeout(() => {
        this.setState({ showError: false });
      }, 5000);
      // notification.config({
      //   zIndex: 200000,
      // });
      //  notification.error({
      //   //  message: "Login Error",
      //    description: "Invalid Credentials!",
      //    placement: "topRight",
      //    duration: 5,
      //    className: notification,
      //  });
      // message.error("User that you've entered is incorrect!!");
      // message.error("Invalid Credentials!");
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({ load: true });
    }, DELAY);
    this.getData();

    if (localStorage.checkbox && localStorage.email !== "") {
      this.setState({
        isChecked: true,
        userid: localStorage.userid,
        phone: localStorage.phone,
        password: localStorage.password,
      });
    }
  }

  asyncScriptOnLoad = () => {
    this.setState({ callback: "called!", recaptchaLoaded: true });
  };

  onSubmitAsync = () => {
    this._reCaptchaRef.current.executeAsync().then((value) => {});
  };

  async getData() {
    const res = await axios.get(
      `${process.env.REACT_APP_GEOLOCATION_URL}/json/`
    );
    this.setState({ ipAddress: res.data.IPv4 });
  }

  onFinish = async (values) => {
    const { dispatch } = this.props;
    if (this.state.value == "[empty]") {
      this.setState({ recaptchavalidate: true });
      return;
    }
    if (values.userid && values.password) {
      const hashedPassword = base64_encode(values.password);
      localStorage.userid = values.userid;
      localStorage.phone = values.phone;
      localStorage.password = values.password;
      localStorage.checkbox = values.remember ? "1" : "";

      const loginResponse = await dispatch(
        userActions.login(
          values.userid,
          hashedPassword,
          values.phone,
          this.state.ipAddress,
          this.state.value
        )
      );
      console.log("loginResponse", loginResponse);
      this._reCaptchaRef.current.reset();
    }
    console.log("this.props", this.props);

    const { loggedIn, error } = this.props;
    this.setState({
      loggedIn: loggedIn,
      error: error,
    });
    const cityId = localStorage.getItem("cityId");

    // if (cityId) this.getVerificationAndAppUsers();
  };

  getVerificationAndAppUsers = async () => {
    try {
      const cityId = localStorage.getItem("cityId");
      if (!cityId || cityId === "0") {
        console.log("No valid cityId found, skipping API calls.");
        localStorage.setItem("allocatedVerification", "");
        localStorage.setItem("appUsers", "[]");
        return;
      }

      const verificationResponse =
        await professionalAction.getVerificationAllocation(cityId);
      if (!verificationResponse.ok) {
        throw new Error(
          `Error fetching verification allocation: ${verificationResponse.statusText}`
        );
      }
      const verificationText = await verificationResponse.text();
      const module = JSON.parse(verificationText);

      localStorage.setItem(
        "allocatedVerification",
        JSON.stringify(module?.data[0])
      );

      if (module?.data[0]?.plan === "Plan C") {
        const appUsersResponse = await professionalAction.getAppUsers(cityId);
        if (!appUsersResponse.ok) {
          throw new Error(
            `Error fetching app users: ${appUsersResponse.statusText}`
          );
        }
        const appUsersText = await appUsersResponse.text();
        const appUsers = JSON.parse(appUsersText);

        localStorage.setItem("appUsers", JSON.stringify(appUsers.data));
      }
    } catch (err) {
      console.error("API Error:", err.message);
    }
  };

  onFinishFailed = (errorInfo) => {};

  handleChange = (value) => {
    this.setState({ value });
    this.setState({ recaptchavalidate: false });
    if (value === null) this.setState({ expired: "true" });
  };

  onChangeCheckbox = (event) => {
    this.setState({
      isChecked: event.target.checked,
    });
  };

  render() {
    const {
      value,
      callback,
      load,
      expired,
      recaptchaLoaded,
      recaptchavalidate,
      ipAddress,
    } = this.state || {};
    const independenceTheme = this.props.independenceTheme;

    return (
      <>
        {this.state.showError && (
          <div className="custome-message">{this.state.errorMessage}</div>
        )}
        <div className="login-panel">
          <div className="login-panel-inner">
            {/* Heading */}
            <div className="login-title">
              {independenceTheme && (
                <div className="ind-day-login-header">
                  <img
                    className="ind-day-login-banner"
                    src={independenceLoginBanner}
                    alt="15 August Independence Day"
                  />
                </div>
              )}
              <h1>CMIS</h1>
              <p>CRIMINAL MONITORING INTELLIGENT SYSTEM</p>
              {independenceTheme && <div className="ind-day-tricolor-line" />}
            </div>

            {/* Card */}
            <Card className="login-panel-card" bordered={false}>
              <Form
                name="basic"
                layout="vertical"
                initialValues={{
                  remember: true,
                  userid: this.state.userid,
                  phone: this.state.phone,
                  password: this.state.password,
                }}
                onFinish={this.onFinish}
                onFinishFailed={this.onFinishFailed}
              >
                <Form.Item
                  name="userid"
                  rules={[{ required: true, message: "Enter User ID" }]}
                >
                  <Input prefix={<UserOutlined />} placeholder="User ID" />
                </Form.Item>

                <Form.Item
                  name="phone"
                  rules={[{ required: true, message: "Enter Mobile Number" }]}
                >
                  <Input
                    prefix={<PhoneOutlined />}
                    placeholder="Mobile Number"
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  rules={[{ required: true, message: "Enter Password" }]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Password"
                  />
                </Form.Item>

                <Form.Item name="remember" valuePropName="checked">
                  <Checkbox className="login-remember">Remember me</Checkbox>
                </Form.Item>

                {load && (
                  <div className="login-recaptcha">
                    <div className="recaptcha_div">
                      <ReCAPTCHA
                        style={{ display: "inline-block" }}
                        ref={this._reCaptchaRef}
                        sitekey={TEST_SITE_KEY}
                        onChange={this.handleChange}
                        asyncScriptOnLoad={this.asyncScriptOnLoad}
                        required
                      />
                      {recaptchavalidate && (
                        <div className="ant-form-item-explain ant-form-item-explain-error">
                          <div role="alert">Please Checked Captcha!</div>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                <Form.Item>
                  <Button htmlType="submit" block className="login-btn">
                    Sign In
                  </Button>
                </Form.Item>
              </Form>
            </Card>

            {independenceTheme && (
              <div className="ind-day-login-footer">
                <p className="ind-day-slogan">
                  स्वातंत्र्याचा अभिमान, सुरक्षिततेची जबाबदारी
                </p>
                <p className="ind-day-jaihind">जय हिंद ! वंदे मातरम् !</p>
              </div>
            )}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn, error } = state.authentication;
  return {
    loggedIn,
    error,
  };
}
const connectedLoginPage = connect(mapStateToProps)(NewLoginPage);
export { connectedLoginPage as NewLoginPage };
